import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-phlebo-route',
  templateUrl: './phlebo-route.component.html',
  styleUrls: ['./phlebo-route.component.scss']
})
export class PhleboRouteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
